import React, { Component } from 'react';

/**
 * Screen for showing help for conversations.
 *
 * @extends React.Component
 */
class Conversations extends Component {
  render() {
    return (
      <div className="widget">
        <h1 id="samtaler">Samtaler</h1>
        <p>Samtaler i menuen danner udgangspunkt for samtaler med børn og unge.</p>
        <h2 id="sådan-oprettes-en-samtale">Sådan oprettes en samtale</h2>
        <ol>
          <li>
            <p>Når en bruger sender en SMS til SMS-rådgivningen vil de modtage et autosvar, hvor de bliver bedt om at angive deres køn og deres alder. En bruger skal f.eks. svare “dreng 14”, hvis brugeren er en dreng på 14 år.</p>
          </li>
          <li>
            <p>Når de svarer på denne besked, så vil de igen modtage et autosvar, og samtalen vil blive oprettet, så den kan ses under <em>Åbne</em> under menupunktet <em>Samtaler</em>.</p>
          </li>
          <li>
            <p>Nu er den klar til at en frivillig kan overtage samtalen, og begynde at skrive med brugeren.</p>
          </li>
        </ol>
        <p>Hvis en bruger har ligget klar til rådgivning i en halv time vil de modtage et autosvar, om at de stadig er i kø.</p>
        <h2 id="sådan-overtager-du-en-samtale">Sådan overtager du en samtale</h2>
        <p>Når du er klar til at rådgive en bruger, så skal du vælge den øverste samtale under <em>Åbne</em> under menupunktet <em>Samtaler</em>. Når du klikker på samtalen vil den åbnes op, og du kan se alle beskeder der er sendt fra og til barnet, inklusiv autosvar.</p>
        <p>Hvis du vil overtage samtalen, så skal du trykke på <em>Overtag samtale</em>.</p>
        <p>Når du har overtaget en samtale er det dit ansvar at svare brugeren med det samme. De vil ikke længere modtage beskeder om at de stadig er i kø.</p>
        <p>På samtalen er det muligt at angive navn, alder, køn, status, frivillig status og noter ude i højre side. Så snart der indtastes noget er det gemt i systemet.</p>
        <p>Så længe du har en samtale er den låst for andre. Det er derfor meget vigtigt at du husker at lægge samtaler tilbage i kø, når du går hjem, eller af andre årsager ikke kan fortsætte samtalen.</p>
        <h2 id="sådan-lægger-du-en-samtale-tilbage-i-kø">Sådan lægger du en samtale tilbage i kø</h2>
        <p>Hvis du ikke kan fortsætte rådgivningen, og derfor har behov for at lægge samtalen tilbage i kø kan du trykke på knappen <em>Læg i kø</em> nederst i højre side, når samtalen er valgt.</p>
        <p>Samtalen vil herefter komme tilbage i kø, og en anden frivillig kan tage over.</p>
        <h2 id="sådan-afslutter-du-en-samtale">Sådan afslutter du en samtale</h2>
        <p>Er rådgivningen afsluttet, så skal du huske at markere samtalen som afsluttet. Dette gøres ved at trykke på knappen <em>Afslut</em> nederst i højre side, når samtalen er valgt.</p>
        <p>Brugeren vil herefter få et autosvar, med et link til et evalueringsskema de kan udfylde.</p>
        <p>Hvis brugeren på et hvilket som helst tidspunkt skriver “Stop samtale” vil samtalen automatisk afsluttes, og du vil ikke længere kunne se samtalen.</p>
      </div>
    );
  }
}

export default Conversations;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Help/screens/Conversations/index.js